import React, { lazy } from 'react';
import 'rc-tooltip/assets/bootstrap.css';
import { useTranslation } from 'react-i18next';
import LeftForm from './LeftForm';
import RightForm from './RightForm';

const layout = window.$environment?.CURRENT_LAYOUT;
const SubHeader = lazy(() => import(`globalcomponents/SubHeader/${layout}`));

const Company = ({ values, handleEdit, errors, isNotValid, Styled, hasSaveApiStatus, states, webfleetProviders }) => {
  const i18n = useTranslation();

  return (
    <div className="section-wrapper">
      <SubHeader text={i18n.t('common.mainInformation')} className="subheaderSection companyTitle" variant="h2" />
      <Styled.wrapperSection>
        <LeftForm {...{ values, handleEdit, errors, isNotValid, Styled, hasSaveApiStatus }} />
        <RightForm {...{ values, handleEdit, errors, isNotValid, Styled, hasSaveApiStatus, states, webfleetProviders }} />
      </Styled.wrapperSection>
    </div>
  );
};

export default Company;
